import React, { useState } from 'react';

export const InfoBlocksSection: React.FC = () => {
  const [expandedCard, setExpandedCard] = useState(0);

  const infoBlocks = [
    {
      title: 'Особенности игры на рубли в онлайн казино',
      description: 'Рублевые счета, отсутствие конвертации, привычные платежные методы',
      image: 'https://public.readdy.ai/ai/img_res/7309598f0299134da2054a1807ebf603.jpg'
    },
    {
      title: 'Популярные слоты в российских онлайн казино',
      description: 'Топовые игровые автоматы от ведущих провайдеров с высоким RTP',
      image: 'https://readdy.ai/api/search-image?query=colorful%20slot%20machine%20reels%20with%20popular%20game%20symbols%20and%20jackpot%20elements%2C%20exciting%20casino%20gaming%20atmosphere%2C%20vibrant%20dynamic%20composition%20on%20dark%20background%2C%20professional%203d%20render%2C%20high%20quality%20digital%20art&width=500&height=400&seq=28&orientation=landscape'
    },
    {
      title: 'Поддержка на русском языке: на что обратить внимание',
      description: 'Круглосуточная поддержка, русскоязычные операторы, быстрые ответы',
      image: 'https://readdy.ai/api/search-image?query=friendly%20customer%20support%20operator%20with%20headset%20helping%20casino%20players%2C%20professional%20service%20concept%2C%20warm%20welcoming%20atmosphere%20on%20soft%20background%2C%20modern%20office%20setting%2C%20high%20quality%20photography&width=500&height=400&seq=29&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {infoBlocks.map((block, index) => (
            <div
              key={index}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                expandedCard === index ? 'md:col-span-2' : 'md:col-span-1'
              }`}
              onClick={() => setExpandedCard(index)}
              style={{ height: '400px' }}
            >
              <img
                src={block.image}
                alt={block.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{block.title}</h3>
                {expandedCard === index && (
                  <p className="text-base opacity-90 leading-relaxed">{block.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};